<template>
  <b-overlay
    :opacity="0.5"
    :show="loading"
    rounded="sm"
    :blur="'true'"
  >
    <b-card>
      <div>
        <ValidationObserver
          ref="createStaffForm"
          v-slot="{ handleSubmit }"
          slim
        >
          <b-form
            ref="form"
            class="repeater-form"
            autocomplete="off"
            @submit.prevent="handleSubmit(onClickSubmit)"
          >
            <b-row class="ml-md-1">
              <b-col
                cols="12"
                md="5"
                class="mt-2"
              >
                <b-form-group
                  label="Business Profile*"
                  label-for="merchantBusiness"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="h-c-merchantBusiness"
                    vid="h-c-merchantBusiness"
                    rules="required"
                  >
                    <v-select
                      v-model="merchant_business_id"
                      :options="businesses"
                      :reduce="option => option.id"
                      label="business_name"
                      placeholder="Select Business profile"
                      autocomplete="nope"
                      @input="!orderSettings.origin_city_freeze ? getAddress() : () =>{}"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="ml-md-1">
              <b-col
                v-if="!orderSettings.origin_city_freeze"
                cols="12"
                md="5"
                class="mt-2"
              >
                <b-form-group
                  label="Pickup Address*"
                  label-for="pickupAddress"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="pickupAddress"
                    rules="required"
                  >
                    <v-select
                      v-model="pickupAddress"
                      :options="businessAddresses"
                      :reduce="option => option.id"
                      label="pickup_address"
                      autocomplete="nope"
                      placeholder="Select Pickup Address"
                      @input="setDefaultOriginCity()"
                    >
                      <template v-slot:option="option">
                        {{ option.pickup_address }}
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="!orderSettings.origin_city_freeze"
                cols="12"
                md="6"
                class="mt-2 ml-md-1"
              >
                <b-form-group
                  label="Origin City*"
                  label-for="originCity"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="h-c-originCity"
                    vid="h-c-originCity"
                    rules="required"
                  >
                    <b-form-input
                      v-model="origin_city_id"
                      :hidden="true"
                    />
                    <b-form-input
                      v-model="origin_city_name"
                      disabled="true"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Col Loop -->
            <b-col
              v-for="(order, index) in orders"
              :id="order.id"
              :key="index"
              ref="row"
            >
              <b-col
                cols="3"
                md="1"
              >
                <hr>
              </b-col>
              <b-col cols="5">
                <h6>{{ numberToWordWithTh(index + 1) }} Order</h6>
              </b-col>
              <b-col cols="9">
                <hr>
              </b-col>

              <div class="mt-2 ml-md-1 font-weight-bolder">
                Package Details
              </div>
              <b-row>
                <!-- Waybill No -->
                <b-col
                  cols="12"
                  md="5"
                  class="mt-2 ml-md-1"
                >
                  <b-form-group
                    label="Waybill No"
                    label-for="waybillNo"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-waybillNo"
                      vid="h-c-waybillNo"
                      :rules="is_waybill_auto ? '' : 'required'"
                    >
                      <b-form-input
                        id="waybillNo"
                        v-model="order.waybill_number"
                        :placeholder="waybillPlaceholder(is_waybill_auto)"
                        :disabled="is_waybill_auto == true"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <!-- Order No -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-2 ml-md-1"
                >
                  <b-form-group
                    label="Order No"
                    label-for="orderNo"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-orderNo"
                      vid="h-c-orderNo"
                    >
                      <b-form-input
                        id="orderNo"
                        v-model="order.order_no"
                        placeholder="001"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <!-- COD Amount -->
                <b-col
                  cols="12"
                  md="5"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="COD Amount*"
                    label-for="cod"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-cod"
                      vid="h-c-cod"
                      rules="required"
                    >
                      <b-form-input
                        id="cod"
                        v-model="order.cod"
                        type="number"
                        placeholder="Item value + Delivery Charge"
                        step=".01"
                        pattern="^\d*(\.\d{0,2})?$"
                        :maxlength="maxCodLength"
                        oninput="if(this.maxLength > 0 && this.value.length > this.maxLength) { this.value = this.value.slice(0, this.maxLength); }"
                        autocomplete="off"
                        no-wheel
                        @keydown.up.prevent
                        @keydown.down.prevent
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
                <!-- Weight -->
                <b-col
                  cols="12"
                  md="6"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Weight*"
                    label-for="weight"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-weight"
                      vid="h-c-weight"
                      rules="required"
                    >
                      <b-input-group>
                        <b-form-input
                          id="weight"
                          v-model="order.weight"
                          type="number"
                          placeholder="1"
                          autocomplete="nope"
                          step=".01"
                          pattern="^\d*(\.\d{0,2})?$"
                          :class="{ 'is-invalid': maxWeightError }"
                          no-wheel
                          @input="checkMaxWeight(order)"
                          @keydown.up.prevent
                          @keydown.down.prevent
                        />
                        <b-input-group-append is-text>
                          <b>Kg</b>
                        </b-input-group-append>
                      </b-input-group>
                      <small
                        v-if="order.maxWeightError"
                        class="text-danger"
                      >{{ order.maxWeightError }}</small>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="mt-2 ml-md-1 font-weight-bolder">
                Customer Details
              </div>
              <b-row>
                <!-- Customer Name -->
                <b-col
                  cols="12"
                  md="5"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Customer Name*"
                    label-for="customerName"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-customerName"
                      vid="h-c-customerName"
                      rules="required"
                    >
                      <b-form-input
                        id="customerName"
                        v-model="order.customer_name"
                        placeholder="Alex"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <!-- Address -->
                <b-col
                  cols="12"
                  md="6"
                >
                  <b-form-group
                    label="Address*"
                    label-for="address"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-address"
                      vid="h-c-address"
                      rules="required"
                    >
                      <b-form-input
                        id="address"
                        v-model="order.customer_address"
                        placeholder="Colombo 07"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <!-- Email -->
                <b-col
                  cols="12"
                  md="5"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="order.customer_email"
                      type="email"
                      placeholder="abc@parallax.lk"
                      autocomplete="nope"
                    />
                  </b-form-group>
                </b-col>
                <!-- Destination City -->
                <b-col
                  cols="12"
                  md="6"
                >
                  <b-form-group
                    label="Destination City*"
                    label-for="city"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-city"
                      vid="h-c-city"
                      rules="required"
                    >
                      <v-select
                        v-model="order.destination_city_id"
                        :options="cityOptions"
                        :reduce="option => option.id"
                        label="name"
                        placeholder="Select City"
                        autocomplete="nope"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <!-- Phone No -->
                <b-col
                  cols="12"
                  md="5"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Primary Phone No*"
                    label-for="customerPhone"
                  >
                    <ValidationProvider
                      #default="{ errors }"
                      name="h-c-customerPhone"
                      vid="h-c-customerPhone"
                      rules="required"
                    >
                      <b-form-input
                        id="customerPhone"
                        v-model="order.customer_phone"
                        type="number"
                        placeholder="0xxxxxxxxx"
                        autocomplete="nope"
                        no-wheel
                        @keydown.up.prevent
                        @keydown.down.prevent
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <!--Second Phone No -->
                <b-col
                  v-if="orderSettings.second_phone_number"
                  cols="12"
                  md="6"
                >
                  <b-form-group
                    label="Second Phone No"
                    label-for="secondPhoneNumber"
                  >
                    <b-form-input
                      id="secondPhoneNumber"
                      v-model="order.customer_secondary_phone"
                      type="number"
                      placeholder="0xxxxxxxxx"
                      autocomplete="nope"
                      no-wheel
                      @keydown.up.prevent
                      @keydown.down.prevent
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="mt-2 mb-2 ml-md-1 font-weight-bolder">
                Other Details
              </div>
              <b-row>
                <!-- Order Description -->
                <b-col
                  cols="12"
                  md="5"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Order Description"
                    label-for="description"
                  >
                    <ValidationProvider
                      name="h-c-description"
                      vid="h-c-description"
                      rules=""
                    >
                      <b-form-textarea
                        id="description"
                        v-model="order.description"
                        placeholder="Description"
                        :class="order.description.length >= maxChar ? 'text-danger' : ''"
                        :maxlength="maxChar"
                        autocomplete="nope"
                      />
                      <small
                        class="textarea-counter-value float-right"
                        :class="order.description.length >= maxChar ? 'bg-danger' : ''"
                      >
                        <span class="char-count">{{ order.description.length }}</span> / {{ maxChar }}
                      </small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

                <!-- Remarks -->
                <b-col
                  cols="12"
                  md="6"
                  class="ml-md-1"
                >
                  <b-form-group
                    label="Remarks"
                    label-for="remark"
                  >
                    <ValidationProvider
                      name="h-c-remark"
                      vid="h-c-remark"
                      rules=""
                    >
                      <b-form-textarea
                        id="remark"
                        v-model="order.remark"
                        placeholder="Extra Details"
                        autocomplete="nope"
                        :class="order.remark.length >= maxChar ? 'text-danger' : ''"
                        :maxlength="maxChar"
                      />
                      <small
                        class="textarea-counter-value float-right"
                        :class="order.remark.length >= maxChar ? 'bg-danger' : ''"
                      >
                        <span class="char-count">{{ order.remark.length }}</span> / {{ maxChar }}
                      </small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-col
                cols="12"
                class="d-flex justify-content-end mb-1"
              >
                <!-- Remove Button -->
                <b-button
                  variant="outline-danger"
                  class="mb-1 mt-1 mt-md-2 mr-md-2 mr-xl-4"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Delete</span>
                </b-button>
              </b-col>
            </b-col>

            <b-col
              cols="12"
              md="12"
            >
              <b-col cols="12">
                <hr>
              </b-col>
              <b-row class="d-flex justify-content-center justify-content-md-end mr-md-3 mr-xl-5 mt-3 mb-1">
                <b-button
                  class="custom-button-color-blur"
                  @click="onClickAdd"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class="mr-25"
                  />
                  <span>Add New</span>
                </b-button>
                &nbsp;
                <b-button
                  type="submit"
                  class="custom-button-color"
                >
                  <feather-icon
                    icon="UploadCloudIcon"
                    class="mr-24"
                  />
                  <span> Submit</span>
                </b-button>
              </b-row>
            </b-col>
          </b-form>
        </ValidationObserver>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BButton, BCard, BOverlay, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
// eslint-disable-next-line import/named
import { numberToWordWithTh } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ResourceRepository = RepositoryFactory.get('resource')
const OrderRepository = RepositoryFactory.get('order')
const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  name: 'BulkOrderCreate',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BRow,
    BCol,
    BButton,
    BCard,
    BOverlay,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
  },
  mixins: [SuccessMessage, ErrorMessage],
  props: {
    orderSettings: {
      type: Object,
      default: null,
    },
    waybillPlaceholder: {
      type: Function,
      default: () => {},
    },
    waybillPattern: {
      type: Function,
      default: () => {},
    },
    patternTitle: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      businesses: [],
      businessAddresses: [],
      states: [],
      cityOptions: [],
      is_waybill_auto: true,
      merchant_business_id: '',
      loading: false,
      concat: true,
      state_id: 0,
      origin_city_id: '',
      pickupAddress: '',
      defaultPickAddressId: '',
      orders: [
        {
          order_no: '',
          customer_name: '',
          customer_address: '',
          customer_phone: '',
          customer_secondary_phone: '',
          customer_email: '',
          destination_city_id: '',
          cod: '',
          weight: '',
          description: '',
          remark: '',
          typingtimer: null,
          isMaxWeight: false,
          validationState: null,
          validationMessage: '',
          maxWeightError: null,
        },
      ],
      search: '',
      maxChar: 190,
    }
  },
  computed: {
    maxCodLength() {
      if (this.orderSettings.cod_range_setting && this.orderSettings.cod_range_setting.enabled && this.orderSettings.cod_range_setting.max_cod_amount) {
        // Integer digits + decimal point + 2 cents digits
        return Math.floor(Number(this.orderSettings.cod_range_setting.max_cod_amount)).toString().length + 3
      }
      return null
    },
  },
  async mounted() {
    this.loading = true
    await this.getMerchantBusinessSettingsDetails()
    await this.getBusinessList()
    await this.getStateList()
    await this.getCityList()
    this.loading = false
  },
  methods: {
    numberToWordWithTh,
    onClickAdd() {
      this.orders.push(
        {
          order_no: '',
          customer_name: '',
          customer_address: '',
          customer_phone: '',
          customer_secondary_phone: '',
          customer_email: '',
          destination_city_id: '',
          cod: '',
          weight: '',
          description: '',
          remark: '',
        },
      )
    },
    removeItem(index) {
      this.orders.splice(index, 1)
    },
    async getMerchantBusinessSettingsDetails() {
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.is_waybill_auto = data.is_waybill_auto
        this.$emit('set-placeholder')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getStateList() {
      try {
        const { data } = (await ResourceRepository.getStateList()).data
        this.states = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityListDropdownList()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getBusinessList() {
      try {
        this.loading = true
        const { data } = (await ResourceRepository.getBusinessList()).data
        this.businesses = data
        if (this.businesses.length === 1) {
          this.merchant_business_id = this.businesses[0].id
          await this.getAddress()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    checkMaxWeight(order) {
      const minWeight = this.orderSettings.weight_range_setting.min_weight
      const maxWeight = this.orderSettings.weight_range_setting.max_weight
      const currentWeight = parseFloat(order.weight)

      if (this.orderSettings.weight_range_setting.enabled === true && (currentWeight < minWeight || currentWeight > maxWeight)) {
        this.$set(order, 'maxWeightError', `The order weight should be between ${minWeight} Kg to ${maxWeight} Kg`)
      } else {
        this.$set(order, 'maxWeightError', null)
      }
    },
    async getAddress() {
      this.loading = true
      try {
        this.businessAddresses = (await MerchantRepository.getbusinessAddresses(this.merchant_business_id, this.concat)).data.data
        localStorage.setItem('address', JSON.stringify(this.businessAddresses))
        this.defaultPickAddressId = (this.businessAddresses.filter(address => address.is_default))[0].id
        if (this.defaultPickAddressId) {
          this.pickupAddress = this.defaultPickAddressId
          await this.setDefaultOriginCity()
        }
        // const { data } = (await MerchantRepository.getMerchantBusinessDetails(this.merchant_business_id)).data
        // await this.getCityList(data.default_address.city.name)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setDefaultOriginCity() {
      try {
        this.loading = true
        const cities = JSON.parse(localStorage.getItem('address'))
        // Loop through the array and check for a matching city id
        let cityId = null
        let cityName = null
        cities.forEach(city => {
          if (city.id === this.pickupAddress) {
            cityId = city.city_id
            cityName = city.city_name
          }
        })
        if (cityId) {
          this.origin_city_id = cityId
          this.origin_city_name = cityName
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async onClickSubmit() {
      this.loading = true
      const payload = {
        general_data: {
          merchant_business_id: this.merchant_business_id,
          origin_city_id: this.origin_city_id,
          pickup_address_id: this.pickupAddress,
        },
        order_data: this.orders,
      }
      if (!payload.general_data.origin_city_id) delete payload.general_data.origin_city_id
      try {
        const { data } = (await OrderRepository.createBulkOrder(payload)).data
        this.showSuccessMessage('Order created successfully')
        sessionStorage.setItem('newlyAddedWaybills', data.toString())
        await this.$router.replace('/all-orders')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../@core/scss/button-color.scss';
</style>
